/**
 * String.prototype.isValidDate
 *
 * @return Boolean
 */
String.prototype.isValidDate = function () {
     var s = this.toString();

    /** format D(D)/M(M)/(YY)YY **/
    var dateFormat = /^\d{1,2}[\.|\/|-]\d{1,2}[\.|\/|-]\d{1,4}$/

    /** format (YY)YY/M(M)/D(D) **/
    var dateFormatReverse = /^\d{1,4}[\.|\/|-]\d{1,2}[\.|\/|-]\d{1,2}$/

    if (dateFormat.test(s) || dateFormatReverse.test(s)) {
        var dateArray = [];

        if(dateFormatReverse.test(s)) {
            /** remove any leading zeros from date values **/
            s = s.replace(/0*(\d*)/gi,"$1");
            dateArray = (s.split(/[\.|\/|-]/)).reverse();
        } else {
            /** remove any leading zeros from date values **/
            s = s.replace(/0*(\d*)/gi,"$1");
            dateArray = s.split(/[\.|\/|-]/);
        }

        /** correct month value **/
        dateArray[1] = dateArray[1] - 1;

        dateArray.forEach((value, key) => {
            dateArray[key] = Math.abs(value);
        })

        var testDate = new Date(dateArray[2], dateArray[1], dateArray[0]);
        if (testDate.getDate()!=dateArray[0] || testDate.getMonth()!=dateArray[1] || (testDate.getYear()!=dateArray[2] && testDate.getFullYear()!=dateArray[2])) {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}

/**
 * String.prototype.toDate
 *
 * @return Boolean
 */
String.prototype.toDate = function () {
    var s = this.toString();

    if(!s.isValidDate())
        return false;

    /** format YYYY-MM-DD **/
    var dateFormatReverse = /^\d{1,4}[\.|\/|-]\d{1,2}[\.|\/|-]\d{1,2}$/

    var dateArray = [];

    if(dateFormatReverse.test(s)) {
        /** remove any leading zeros from date values **/
        s = s.replace(/0*(\d*)/gi,"$1");
        dateArray = (s.split(/[\.|\/|-]/)).reverse();
    } else {
        /** remove any leading zeros from date values **/
        s = s.replace(/0*(\d*)/gi,"$1");
        dateArray = s.split(/[\.|\/|-]/);
    }

    /** correct month value **/
    dateArray[1] = dateArray[1] - 1;

    dateArray.forEach((value, key) => {
        dateArray[key] = Math.abs(value);
    })

    return new Date(dateArray[2], dateArray[1], dateArray[0]);

}

/**
 * String.polyfill.startsWith
 *
 * @return Boolean
 * https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
 */
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position){
      return this.substr(position || 0, searchString.length) === searchString;
  };
}

/**
 * Syring.polyfill.includes
 *
 * @return Boolean
 * https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/String/includes
 */
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }
    
    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}


// WEBPACK FOOTER //
// ./src/api/prototypes/String.js